import { useUpdateOrgInvitationRetryInterval } from "@/apiQueries/useUpdateOrgInvitationRetryInterval";

import { useRedux } from "@/hooks/useRedux";
import { useSettingsToggle } from "@/hooks/useSettingsToggle";

import { CardEditableNumberForm } from "./CardEditableNumberForm";
import { CardWithToggler } from "./CardWithToggler";

const DEFAULT_INTERVAL_DAYS = 2;

export const SettingsEnableReceiverInvitationRetry = () => {
  const { organization } = useRedux("organization");
  const currentInterval = organization.data.receiverInvitationResendInterval ?? 0;

  const { isChecked, isPending, error, handleToggleChange, mutateAsync } = useSettingsToggle({
    currentValue: currentInterval,
    useUpdateMutation: useUpdateOrgInvitationRetryInterval,
    getNextValue: (current): number => (current === 0 ? DEFAULT_INTERVAL_DAYS : 0),
  });

  return (
    <CardWithToggler
      toggleId="receiver-invitation-retry"
      label="Enable automatic message retry"
      note="Select this option to automatically re-send the invitation message to unregistered receivers after a certain time period. They will receive the same message again. The message will only go to receivers who have not registered their wallet."
      isChecked={isChecked}
      isPending={isPending}
      error={error}
      onToggleChange={handleToggleChange}
    >
      {currentInterval ? (
        <CardEditableNumberForm
          inputId="receiver-invitation-retry-interval"
          label="Receiver invitation retry interval (days)"
          currentValue={currentInterval}
          zeroValueError="Retry interval cannot be 0"
          isPending={isPending}
          onSubmit={(next) => mutateAsync(next)}
        />
      ) : null}
    </CardWithToggler>
  );
};
